import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import HourglassStart from './icon-hourglass-start.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <HourglassStart {...validProps} />;
}
SvgComponent.iconName = 'hourglassStart';

/**
 * @deprecated This is a legacy icon
 */
export const HourglassStartIcon = svgIconWrapper(SvgComponent);
